const prefix = 'surveyFormat';

const REGISTER = `${prefix}/REGISTER` as const;
const UNREGISTER = `${prefix}/UNREGISTER` as const;
const SET_ACTIVE = `${prefix}/SET_ACTIVE` as const;
const SET_FORMAT = `${prefix}/SET_FORMAT` as const;
export const SurveyAction = {
  REGISTER,
  UNREGISTER,
  SET_FORMAT,
  SET_ACTIVE,
};

export const SurveyFormat = {
  CLASSIC: 'CLASSIC' as const,
  CONVERSATIONAL: 'CONVERSATIONAL' as const,
  ONE_QUESTION_AT_A_TIME: 'ONE_QUESTION_AT_A_TIME' as const,
  SYMPTOM_TRACKING: 'SYMPTOM_TRACKING' as const,
} as const;

export default SurveyAction;
